import { ImageRadioButton } from 'app/agriculture/components/ImageRadioButton/ImageRadioButton';
import { useContext } from 'react';
import { ServicesContext } from 'app/items/shared/context_interface';
import { TerrainLayerSection } from 'app/agriculture/AgMapBoxStack/components/TerrainLayerSection/TerrainLayerSection';
import { ShowOnMapSection } from 'app/agriculture/AgMapBoxStack/components/ShowOnMapSection/ShowOnMapSection';
import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';
import { TerrainModeContext } from 'app/agriculture/contexts/TerrainProviderContext';
import { ContentLayout } from 'app/agriculture/components/ContentLayout/ContentLayout';

export function MapOptionsBox() {
    const { terrainService } = useContext(ServicesContext);
    const { terrainEnabled } = useContext(TerrainModeContext);

    return (
        <ContentLayout className="MapOptionsBox" includeSeparator>
            <SimpleGrid columns={2}>
                <ImageRadioButton
                    label={'Satellite'}
                    onToggle={() => {
                        terrainService.setMapTerrainEnabled(false).catch((e) => {
                            console.error(e);
                        });
                    }}
                    toggled={!terrainEnabled}
                    image={'assets/agriculture/satellite.png'}
                />
                <ImageRadioButton
                    label={'Terrain'}
                    onToggle={() => {
                        terrainService.setMapTerrainEnabled(true).catch((e) => {
                            console.error(e);
                        });
                    }}
                    toggled={terrainEnabled}
                    image={'assets/agriculture/terrain.png'}
                />
            </SimpleGrid>
            <TerrainLayerSection isTerrainEnabled={terrainEnabled} />
            <ShowOnMapSection />
        </ContentLayout>
    );
}
